import { createContext, useMemo, useState } from 'react';
import { format, parse, setHours, setMinutes } from 'date-fns';
import { getEnvValueFor } from '../../helpers/utils';
import CompanyEvents from './companyEvents';

export const DashboardEventsContext = createContext<{
  setStartDate: any;
  setStartTime: any;
  setDashboard: any;
  isLiveDashboard: boolean;
  updateCompanyId: (id: number | null) => void;
  updateBusinessStartDateTime: (date?: string, time?: [number, number]) => void;
}>(undefined as any);

interface DashboardEventsProps {
  children: React.ReactNode;
}

const DashboardEvents = ({ children }: DashboardEventsProps) => {
  const [companyId, setCompanyId] = useState<null | number>(null);
  const [startDate, setStartDate] = useState<string>('');
  const [startTime, setStartTime] = useState<[number, number]>([0, 0]);
  const [dashboard, setDashboard] = useState<string>('');
  const [businessStartDate, setBusinessStartDate] = useState<string>(
    format(new Date(), 'yyyy-MM-dd')
  );
  const [businessStartTime, setBusinessStartTime] = useState<[number, number]>([0, 0]);
  const disableCompanyDataPushEvents = JSON.parse(
    getEnvValueFor('DISABLE_DASHBOARD_AUTO_PUSH') || 'false'
  );

  const updateBusinessStartDateTime = (
    date: string = format(new Date(), 'yyyy-MM-dd'),
    time: [number, number] = [0, 0]
  ) => {
    setBusinessStartDate(date);
    setBusinessStartTime(time);
  };

  const updateCompanyId = (id: null | number = null) => {
    setCompanyId(id);
  };

  const isCurrentDay = useMemo(() => {
    const businessStartDateTime = setHours(
      setMinutes(parse(businessStartDate, 'yyyy-MM-dd', new Date()), businessStartTime[1]),
      businessStartTime[0]
    );
    const startDateTime = setHours(
      setMinutes(parse(startDate, 'yyyy-MM-dd', new Date()), startTime[1]),
      startTime[0]
    );
    return startDateTime >= businessStartDateTime;
  }, [startDate, startTime, businessStartDate, businessStartTime]);

  return (
    <>
      {!disableCompanyDataPushEvents && companyId && dashboard ? (
        <CompanyEvents companyId={companyId} />
      ) : null}
      <DashboardEventsContext.Provider
        value={{
          setStartDate,
          setStartTime,
          setDashboard,
          isLiveDashboard: isCurrentDay,
          updateBusinessStartDateTime,
          updateCompanyId
        }}
      >
        {children}
      </DashboardEventsContext.Provider>
    </>
  );
};

export default DashboardEvents;
